export const SET_USER_DATA = 'setUserData/Success';
export const DATA_USER_MANAGEMENT = 'dataUserManagement/Success';
export const LOADING_USER_MANAGEMENT = 'loadingUserManagement/Success';
